import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { TextField } from "@mui/material";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Header.css";


const Header = ({ children, hasHiddenAuthButtons }) => {
  const [loggedIn, setLoggedIn] = useState(localStorage.getItem('token') ? true: false);
  const history = useHistory();

  const loginView = () => {
    return (
      <Box className="loginView-container"> 
          <div><img  src="avatar.png" alt={localStorage.getItem('username')} ></img></div>
          <div className="username-text"><span >{localStorage.getItem('username')}</span></div>
          <Button onClick={() => {  
            localStorage.clear();
            history.push("/");
            window.location.reload(true);    
          }
            }>LOGOUT</Button>
      </Box>
    );
  };

  const logoutView = () => {
    return (
      <Box className="logoutView-container">
        <Button variant="text" onClick={() => history.push("/login")}>LOGIN</Button>
        <Button variant="contained" onClick={() => { history.push("/register")}}>REGISTER</Button>
      </Box>
    );
  };

  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
      {children}
      {!hasHiddenAuthButtons && (loggedIn ? loginView() : logoutView())}
      {hasHiddenAuthButtons && (
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => history.push("/")}
        >
          Back to explore
        </Button>
      )}
      
    </Box>
  );
};

export default Header;
